import React, { useState } from 'react';
import './App.css';
import FormScreen from './components/FormScreen';
import ThankYouScreen from './components/ThankYouScreen';

function App() {
  const [currentScreen, setCurrentScreen] = useState('form');
  const [submittedData, setSubmittedData] = useState(null);

  const handleFormSubmit = (formData) => {
    console.log('送信データ:', formData);
    setSubmittedData(formData);
    setCurrentScreen('thankyou');
  };

  return (
    <div className="App">
      {currentScreen === 'form' && (
        <FormScreen onSubmit={handleFormSubmit} />
      )}
      {currentScreen === 'thankyou' && (
        <ThankYouScreen participationType={submittedData?.participation} />
      )}
    </div>
  );
}

export default App;